/* =========================================================
   Voluema — theme.js
   Header, mobile menu, scroll reveal, accordion, testimonial
   carousel, sticky add-to-cart, and an AJAX cart drawer.
   ========================================================= */
(function () {
  'use strict';

  var Voluema = (window.Voluema = window.Voluema || {});
  var routes = Voluema.routes || { cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart: '/cart.js' };

  /* ---------- Money formatting (Shopify) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || Voluema.money_format || '{{amount}}';

    function defaultTo(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((f.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = defaultTo(cents, 2, "'", '.'); break;
      default: value = defaultTo(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }
  Voluema.formatMoney = formatMoney;

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-menu-open]');
    var closeEls = document.querySelectorAll('[data-menu-close]');
    if (!menu || !openBtn) return;

    function open() {
      menu.classList.remove('hidden');
      void menu.offsetWidth; // force reflow so the CSS transition plays
      menu.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      menu.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { menu.classList.add('hidden'); }, 300);
    }
    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Accordion (FAQ) ---------- */
  function initAccordion(root) {
    (root || document).querySelectorAll('[data-accordion] .accordion-item').forEach(function (item) {
      var btn = item.querySelector('.accordion-trigger');
      if (!btn || btn.__init) return;
      btn.__init = true;
      btn.addEventListener('click', function () {
        var isOpen = item.hasAttribute('data-open');
        var group = item.closest('[data-accordion]');
        if (group && group.dataset.accordion === 'single') {
          group.querySelectorAll('.accordion-item[data-open]').forEach(function (o) {
            if (o !== item) { o.removeAttribute('data-open'); o.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false'); }
          });
        }
        if (isOpen) { item.removeAttribute('data-open'); btn.setAttribute('aria-expanded', 'false'); }
        else { item.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------- Testimonial / carousel scroller ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (car) {
      if (car.__init) return;
      car.__init = true;
      var track = car.querySelector('[data-carousel-track]');
      var prev = car.querySelector('[data-carousel-prev]');
      var next = car.querySelector('[data-carousel-next]');
      if (!track) return;
      function step() {
        var item = track.querySelector('.snap-item');
        return item ? item.getBoundingClientRect().width + 24 : 320;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Sticky Add-to-Cart ---------- */
  function initStickyATC() {
    var bar = document.querySelector('[data-sticky-atc]');
    var trigger = document.querySelector('[data-sticky-trigger]');
    if (!bar) return;
    if (!('IntersectionObserver' in window) || !trigger) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show the bar once the main buy button has scrolled out of view
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(trigger);
  }

  /* ---------- Cart drawer + AJAX add to cart ---------- */
  function cartCountEls() { return document.querySelectorAll('[data-cart-count]'); }

  function updateCartCount(count) {
    cartCountEls().forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count < 1);
    });
  }

  function renderCart(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var list = drawer.querySelector('.cart-line-items');
    var empty = drawer.querySelector('.cart-empty');
    var footer = drawer.querySelector('.cart-footer');
    var totalEl = drawer.querySelector('.cart-total');
    updateCartCount(cart.item_count);

    if (!cart.items || cart.items.length === 0) {
      list.innerHTML = '';
      if (empty) empty.classList.remove('hidden'), empty.classList.add('flex');
      if (footer) footer.style.display = 'none';
      return;
    }
    if (empty) empty.classList.add('hidden'), empty.classList.remove('flex');
    if (footer) footer.style.display = '';
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    list.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
      return '' +
        '<li class="flex gap-4" data-line-key="' + item.key + '">' +
          '<div class="h-20 w-20 flex-shrink-0 overflow-hidden rounded-2xl bg-sand">' +
            (img ? '<img src="' + img + '" alt="' + (item.title || '') + '" class="h-full w-full object-cover">' : '') +
          '</div>' +
          '<div class="flex-1">' +
            '<div class="flex justify-between gap-3">' +
              '<p class="font-medium leading-tight">' + item.product_title + '</p>' +
              '<button type="button" data-line-remove="' + item.key + '" aria-label="Entfernen" class="text-mocha hover:text-charcoal">&times;</button>' +
            '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="text-sm text-mocha">' + item.variant_title + '</p>' : '') +
            '<div class="mt-2 flex items-center justify-between">' +
              '<div class="inline-flex items-center rounded-full border border-charcoal/15">' +
                '<button type="button" class="px-3 py-1" data-line-minus="' + item.key + '" aria-label="Weniger">–</button>' +
                '<span class="min-w-[1.5rem] text-center text-sm">' + item.quantity + '</span>' +
                '<button type="button" class="px-3 py-1" data-line-plus="' + item.key + '" aria-label="Mehr">+</button>' +
              '</div>' +
              '<span class="font-medium">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</li>';
    }).join('');

    list.querySelectorAll('[data-line-plus]').forEach(function (b) { b.addEventListener('click', function () { changeLine(b.dataset.linePlus, relQty(cart, b.dataset.linePlus, 1)); }); });
    list.querySelectorAll('[data-line-minus]').forEach(function (b) { b.addEventListener('click', function () { changeLine(b.dataset.lineMinus, relQty(cart, b.dataset.lineMinus, -1)); }); });
    list.querySelectorAll('[data-line-remove]').forEach(function (b) { b.addEventListener('click', function () { changeLine(b.dataset.lineRemove, 0); }); });
  }

  function relQty(cart, key, delta) {
    var it = cart.items.filter(function (i) { return i.key === key; })[0];
    return it ? Math.max(0, it.quantity + delta) : 0;
  }

  function changeLine(key, quantity) {
    fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function fetchCart() {
    return fetch(routes.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function openDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    void drawer.offsetWidth; // force reflow so the CSS transition plays
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    fetchCart();
  }
  function closeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.classList.add('hidden'); }, 320);
  }
  Voluema.openCart = openDrawer;

  function initCart() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.querySelector('.cart-overlay').addEventListener('click', closeDrawer);
      drawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    }
    document.querySelectorAll('[data-open-cart]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });

    // Intercept product add-to-cart forms
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Let the "Sofort kaufen" button post straight to checkout
        if (e.submitter && e.submitter.name === 'checkout') return;
        e.preventDefault();
        var btn = e.submitter || form.querySelector('[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'Wird hinzugefügt…'; }
        fetch(routes.cart_add, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function () {
            if (btn) { btn.innerHTML = '✓ Hinzugefügt'; }
            openDrawer();
            setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } }, 1400);
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
            window.location.href = routes.cart.replace('.js', '');
          });
      });
    });
  }

  /* ---------- Quantity steppers (product page) ---------- */
  function initQtySteppers(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.__init) return; wrap.__init = true;
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.__init) return; g.__init = true;
      var main = g.querySelector('[data-gallery-main]');
      if (!main) return;
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (src) main.src = src;
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('ring-blush'); t.classList.add('ring-transparent'); });
          thumb.classList.add('ring-blush'); thumb.classList.remove('ring-transparent');
        });
      });
    });
  }

  /* ---------- Variant select (price + availability) ---------- */
  function initVariant(root) {
    (root || document).querySelectorAll('[data-variant-select]').forEach(function (sel) {
      if (sel.__init) return; sel.__init = true;
      var form = sel.closest('form');
      var priceTarget = document.querySelector('[data-price-target]');
      var submitBtn = form ? form.querySelector('[data-sticky-trigger]') : null;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (priceTarget && opt.dataset.price) priceTarget.textContent = opt.dataset.price;
        if (submitBtn) {
          var avail = opt.dataset.available !== 'false';
          submitBtn.disabled = !avail;
          submitBtn.innerHTML = avail ? 'In den Warenkorb · ' + (opt.dataset.price || '') : 'Ausverkauft';
        }
      });
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    initHeader();
    initMobileMenu();
    initReveal();
    initAccordion();
    initCarousels();
    initStickyATC();
    initCart();
    initQtySteppers();
    initGallery();
    initVariant();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-init dynamic bits inside the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAccordion(e.target);
    initCarousels(e.target);
    initQtySteppers(e.target);
    initGallery(e.target);
    initVariant(e.target);
    initReveal();
  });
})();
